import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from "rxjs";

import { ConsignesSecuriteGeneralesEntity } from "../entities/consignes-securite-generales.entity"

@Injectable({ providedIn: 'root' })
export class ConsignesSecuriteGeneralesService {
    private path: string;

    constructor( //
        @Inject(HttpClient) private httpClient: HttpClient, //
        @Optional() @SkipSelf() previousInstance?: ConsignesSecuriteGeneralesService
    ){
        if (previousInstance) {
            throw new Error(
                'ConsignesSecuriteGeneralesService is already loaded. Import it in the AppModule only');
        }
        this.path = (window as any).baseApiPath;
    }

    public getAllConsignesSecuriteGenerales() : Observable<ConsignesSecuriteGeneralesEntity[]> {
        let url = this.path + "consignesSecuriteGenerales"
        let result = this.httpClient.get<ConsignesSecuriteGeneralesEntity[]>(url);
        return result;
    }
}